<template>
  <div>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialogState" width="440">
          <v-card style="background:#35362F">
            <v-card-title class="headline justify-center white--text">
              Exploration Mode
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-3 white--text">
              <p class="text-center text-body-1">
                You can now interactively explore the <br />
                pyramid by using your mouse or touch pad
              </p>
              <v-row>
                <v-col cols="6">
                  <v-row justify="space-around">
                    <div style="width:70%">
                      <v-img src="/images/click_drag.png" class="margin-auto" />
                    </div>
                  </v-row>
                  <div class="text-center text-body-1 mt-3">
                    Click And Drag <br />
                    to move the camera
                  </div>
                </v-col>
                <v-col cols="6">
                  <v-row justify="space-around">
                    <div style="width:70%">
                      <v-img src="/images/pinch_zoom.png" class="margin-auto" />
                    </div>
                  </v-row>
                  <div class="text-center text-body-1 mt-3">
                    Pinch Or Scroll to <br />
                    zoom in and out
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-center py-3">
              <v-btn color="white" center @click="turnOffDialog" large>
                Next
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogState: false
    }
  },
  watch: {
    dialog(val) {
      this.dialogState = val
    },
    dialogState(val) {
      !val && this.turnOffDialog()
    }
  },
  methods: {
    turnOffDialog() {
      this.dialogState = false
      this.$emit('dialogOff')
    }
  }
}
</script>

<style lang="css" scoped>
.anotation-box {
  order: 1px solid #fff;
  border-radius: 18px;
  font-size: 16px;
  font-family: sans-serif;
  line-height: 26px;
  color: #fff;
  text-align: center;
  user-select: none;
  background: rgba(0, 0, 0, 0.8);
}
</style>
